export default __webpack_public_path__ + "static/media/bti-icon.d9f3f5ea.svg";